import '.a{display:flex;}.ssr-plugin'
import '.as{justify-content:center;}.ssr-plugin'
import '.b{flex-direction:column;}.ssr-plugin'
import '.t{align-items:center;}.ssr-plugin'
import '.u{gap:0.5rem;}.ssr-plugin'
import '.a1{cursor:pointer;}.ssr-plugin'
import '.fr{padding:0.75rem;}.ssr-plugin'
import '.ai{border-radius:1.25rem;}.ssr-plugin'
import '.w{border:var(--border-subtle);}.ssr-plugin'
import '.v{background-color:var(--palette-white);}.ssr-plugin'
import '.f2{transition:background-color 0.2s ease;}.ssr-plugin'
import '.fs{width:2.5rem;}.ssr-plugin'
import '.c1{height:2.5rem;}.ssr-plugin'
import '.ft{color:var(--palette-blue-700);}.ssr-plugin'
import '.fu{font-size:0.9rem;}.ssr-plugin'
import '.a5{font-weight:400;}.ssr-plugin'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { styled } from 'inlines'
import { IconProp } from '@fortawesome/fontawesome-svg-core'
import { MouseEventHandler } from 'react'

export type SocialMediaButtonProps = {
  icon: IconProp
  label: string
  onClick: MouseEventHandler<HTMLButtonElement>
  isMobile?: boolean
}

export const SocialMediaButton = ({
  icon,
  label,
  onClick,
  isMobile,
}: SocialMediaButtonProps) => {
    return (
      <styled.button className="a as b t u a1 fr ai w v f2"
        style={{
          '&:hover': {
            backgroundColor: 'var(--palette-blue-50)',
          },
          width: isMobile ? '8rem' : '5.5rem',
          height: isMobile ? '8rem' : '5.5rem',
        }}
        onClick={onClick}
      >
        <div className="fs c1 a t as ft"
          style={{
            fontSize: isMobile ? '3rem' : '2rem',
          }}
        >
          <FontAwesomeIcon icon={icon} />
        </div>
        <span className="fu ft a5"
        >
          {label}
        </span>
      </styled.button>
    )
}